import {
  IsUUID,
  IsOptional,
  IsString,
  IsPositive,
  IsInt
} from "class-validator";
import { Type } from "class-transformer";

import TestAnswer from "./answer";

export default class TestAnswerVersion {
  @IsUUID("4")
  public readonly id!: string;

  @IsOptional()
  @IsString()
  public value: string = "";

  @IsInt()
  @IsPositive()
  public version: number = 1;

  @IsInt()
  @IsPositive()
  public position: number = 1;

  @Type(() => TestAnswer)
  public answer: TestAnswer = new TestAnswer();

  public is_selected?: boolean;

  constructor(data?: any) {
    if (data) {
      if (typeof data.value === "string") {
        this.value = data.value;
      }

      if (typeof data.version === "number") {
        this.version = data.version;
      }

      if (typeof data.position === "number") {
        this.position = data.position;
      }
    }
  }
}
